export default function initFullCartView(selector, box) {
    const elem = document.getElementById(selector);
    const boxElem = document.getElementById(box);

    if (!elem) {
        return;
    }

    const boxElemHTML = boxElem.innerHTML;
    boxElem.innerHTML = elem.checked ? '' : boxElemHTML;

    elem.addEventListener('change', (e) => {
        boxElem.innerHTML = e.target.checked ? '' : boxElemHTML;
    });
}



// WEBPACK FOOTER //
// ./src/widgets/CheckoutCheckbox.js